import { useMemo, useState } from 'react';

export default function useInputEventState() {
  const [inputEvent, setInputEvent] = useState(null);

  // Returns null when the editor is empty AND when the JSON is invalid.
  // Callers treat "no parsed event available" uniformly in both cases — the
  // editor surfaces the invalid-JSON state to the user separately.
  const parsedInputEvent = useMemo(() => {
    if (!inputEvent) return null;
    try {
      return JSON.parse(inputEvent);
    } catch {
      return null;
    }
  }, [inputEvent]);

  return {
    inputEvent,
    parsedInputEvent,
    setInputEvent,
  };
}
